import 'interactjs';
export function dragMoveListener(event) {
    var _a;
    const el = event.target;
    let [x, y] = JSON.parse((_a = el.dataset.pos) !== null && _a !== void 0 ? _a : '[0,0]');
    x += event.dx;
    y += event.dy;
    // translate the element
    el.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
    // update the posiion attributes
    el.dataset.pos = JSON.stringify([x, y]);
}
export function dragMoveReset(event) {
    const el = event.target;
    delete el.dataset.pos;
    el.style.transform = '';
}
